import React, { useEffect, useState } from "react";
import { Booking, api, IAssetKeysAtLocationPath } from "../../../logic/api";
import usePaths from "../../../utility/paths";
import styles from "../styles";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import KeyLocationListItem from "../../../components/lists/listItems/KeyLocationListItem/KeyLocationListItem";
import HeaderRow from "./condensedLayout/HeaderRow";
import { KeyHeldRow } from "./condensedLayout/key/KeyHeldRow";
import { useTranslation } from "react-i18next";
import { useReleaseManagement, ReleaseFlag } from "../../../utility/feature-management";
import { useHistory } from "react-router-dom";

interface KeysHeldProps {
  isCondensedView?: boolean;
  path: string;
}

const KeysHeld: React.FunctionComponent<KeysHeldProps> = (props) => {

  const paths = usePaths();
  const { t } = useTranslation();
  const history = useHistory();
  const [params, setParams] = useState<IAssetKeysAtLocationPath>({
    path: props.path
  });
  const isOpenLinksInNewTab = useReleaseManagement(ReleaseFlag.releaseOpenLinksInNewTabs);


  useEffect(() => {
    if (props.path != params.path) {
      setParams({
        ...params, path: props.path
      });
    }
  }, [props.path]);

  const handleGoToBooking = (bookingId: number) => {
    if (isOpenLinksInNewTab) {
      window.open(paths.booking(bookingId), "_blank");
    } else {
      history.push(paths.booking(bookingId));
    }
  }

  return <div>
    {props.isCondensedView ? (
      <PagedDataView<IAssetKeysAtLocationPath, Booking>
        apiHook={api.hooks.assetVehicleKey.getAtLocation}
        parameters={params}
        header={() => <HeaderRow columnHeaders={[t("booking.labels.ref"), t("locations.heldBy"), t("booking.labels.keyLocation"), t("locations.vehicleReg"), t("booking.cards.vehicle"), t("locations.heldSince"), ""]} />}
        isTable
        animate={false}
        renderItem={(item, index) => {
          return <KeyHeldRow booking={item} rowIndex={index} onClick={() => handleGoToBooking(item.id)} />
        }}>
        <div style={styles.noDataCondensed}>
          {t("locations.noKeysFoundAtLocation")}
        </div>
      </PagedDataView>
    ) : (
      <PagedDataView<IAssetKeysAtLocationPath, Booking>
        apiHook={api.hooks.assetVehicleKey.getAtLocation}
        parameters={params}
        renderItem={(item) => {
          return <KeyLocationListItem booking={item} onClick={() => handleGoToBooking(item.id)} />
        }}
      >
        <div style={styles.noData}>
          {t("locations.noKeysFoundAtLocation")}
        </div>
      </PagedDataView>
    )}
  </div>
};

export default KeysHeld;
